import { render, staticRenderFns } from "./sidebar-group.vue?vue&type=template&id=5168fd7a"
import script from "./sidebar-group.vue?vue&type=script&lang=js"
export * from "./sidebar-group.vue?vue&type=script&lang=js"
import style0 from "./sidebar-group.vue?vue&type=style&index=0&id=5168fd7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports